import { __assign, __spreadArray } from "tslib";
import { FlatList, StyleSheet, Text, View, Image, TouchableOpacity } from 'react-native';
import React from 'react';
import { PnmacText } from 'pnmac-universal-components';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { currencyFormatter, paymentTypes } from '../../../utils.js';
import moments from 'moment';
var PaymentStatus = function (_a) {
  var status = _a.status,
    translations = _a.translations;
  return /*#__PURE__*/React.createElement(View, {
    style: styles.statusContainer
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: styles.statusText
  }, translations.PaymentStatusTypePending));
};
var RecentPaymentsList = function (_a) {
  var _b;
  var translations = _a.translations,
    layout = _a.layout,
    navigation = _a.navigation;
  var history = ((_b = layout.currentLoanActivity) === null || _b === void 0 ? void 0 : _b.history) || [];
  history.sort(function (a, i) {
    return moments(i.effectiveDate) - moments(a.effectiveDate);
  });
  var data = __spreadArray(__spreadArray([], layout.paymentModel.pendingPayments, true), history.slice(0, 2), true);
  function renderItem(_a) {
    var item = _a.item,
      index = _a.index;
    var label = (layout === null || layout === void 0 ? void 0 : layout.language) === 'es' ? item.spanishTransactionCodeDesc : item.transactionCodeDesc;
    var style = {};
    if (index === 0) {
      style = styles.itemTopStyle;
    } else if (index === data.length - 1) {
      style = styles.itemBottomStyle;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, !label ? /*#__PURE__*/React.createElement(TouchableOpacity, {
      style: [styles.paymentRow, style],
      onPress: function () {
        navigation.navigate('Payment/Pending');
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.paymentRowDetails
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles.paymentRowData]
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [styles.paymentTitlePending, {
        fontStyle: 'italic'
      }]
    }, paymentTypes[item === null || item === void 0 ? void 0 : item.paymentType]), /*#__PURE__*/React.createElement(PnmacText, {
      style: [styles.paymentDate, {
        fontStyle: 'italic'
      }]
    }, moments(item.effectiveDate).format("MMMM DD, yyyy"))), /*#__PURE__*/React.createElement(View, {
      style: {
        alignItems: 'flex-start',
        justifyContent: 'center',
        flex: 0.2,
        marginRight: 10
      }
    }, /*#__PURE__*/React.createElement(PaymentStatus, {
      status: item.status,
      translations: translations
    })), /*#__PURE__*/React.createElement(View, {
      style: styles.paymentRowValueStatus
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.rightContent
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: [styles.pendingPaymentValue, {
        fontStyle: 'italic'
      }]
    }, currencyFormatter('en-US', 'currency', 'USD', item === null || item === void 0 ? void 0 : item.totalDraftAmount)), /*#__PURE__*/React.createElement(Image, {
      source: require("../../../assets/back-chevron.png"),
      style: styles.chevronRight
    }))))) : /*#__PURE__*/React.createElement(TouchableOpacity, {
      style: [styles.paymentRow, style],
      onPress: function () {
        navigation.navigate('Loan/Activity');
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles.paymentRowDetails, style]
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.paymentRowData
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: styles.paymentTitlePending
    }, label), /*#__PURE__*/React.createElement(PnmacText, {
      style: styles.paymentDate
    }, moments(item.effectiveDate).format("MMMM DD, yyyy"))), /*#__PURE__*/React.createElement(View, {
      style: styles.paymentRowValueStatusHistory
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: styles.paymentValue
    }, currencyFormatter('en-US', 'currency', 'USD', item === null || item === void 0 ? void 0 : item.transactionAmount)), /*#__PURE__*/React.createElement(Image, {
      source: require("../../../assets/back-chevron.png"),
      style: styles.chevronRight
    })))));
  }
  function renderSeperator(item) {
    var _a, _b;
    var label = (layout === null || layout === void 0 ? void 0 : layout.language) === 'es' ? (_a = item === null || item === void 0 ? void 0 : item.leadingItem) === null || _a === void 0 ? void 0 : _a.spanishTransactionCodeDesc : (_b = item === null || item === void 0 ? void 0 : item.leadingItem) === null || _b === void 0 ? void 0 : _b.transactionCodeDesc;
    return /*#__PURE__*/React.createElement(View, {
      style: {
        height: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: 'white'
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: label ? {
        height: 0.5,
        backgroundColor: "#707070",
        flex: 0.62
      } : {
        height: 1,
        backgroundColor: "#117AAA",
        flex: 0.62
      }
    }), /*#__PURE__*/React.createElement(View, {
      style: label ? {
        height: 0.5,
        backgroundColor: "#707070",
        flex: 0.35
      } : {
        height: 1,
        backgroundColor: "#117AAA",
        flex: 0.35
      }
    }));
  }
  return /*#__PURE__*/React.createElement(View, {
    style: styles.recentPaymentsView
  }, /*#__PURE__*/React.createElement(FlatList, {
    data: data,
    renderItem: renderItem,
    ListEmptyComponent: /*#__PURE__*/React.createElement(PnmacText, {
      style: styles.noRecentPayment
    }, "No Recent Payments"),
    ItemSeparatorComponent: renderSeperator
  }));
};
var styles = StyleSheet.create({
  listHeader: {
    backgroundColor: "#333333",
    height: 39,
    width: "100%",
    justifyContent: "center"
  },
  headerTitle: {
    fontFamily: "Montserrat",
    fontSize: 11,
    fontWeight: "600",
    textTransform: "uppercase",
    color: "#FFFFFF",
    marginLeft: 30
  },
  paymentRow: {
    backgroundColor: "#FFFFFF",
    height: 72,
    width: "100%",
    paddingLeft: 7.5,
    paddingRight: 9.5
  },
  paymentRowDetails: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#green",
    height: 71.8,
    flex: 1,
    width: "100%"
  },
  itemTopStyle: {
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10
  },
  itemBottomStyle: {
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10
  },
  paymentRowData: {
    backgroundColor: "white",
    justifyContent: "center",
    flex: 0.4,
    paddingLeft: 10
  },
  paymentRowValueStatus: {
    justifyContent: "center",
    alignItems: "center",
    flex: 0.4,
    textAlign: 'right',
    flexDirection: "row",
    backgroundColor: "white"
  },
  paymentRowValueStatusHistory: {
    justifyContent: "flex-end",
    alignItems: "center",
    flex: 0.6,
    textAlign: 'right',
    flexDirection: "row",
    backgroundColor: "white"
  },
  paymentTitlePending: {
    fontSize: 14,
    marginTop: 8.2,
    fontWeight: '500',
    color: "#5C5C5C"
  },
  noRecentPayment: {
    fontFamily: "HalenoirCompactText-Regular",
    fontSize: 14,
    marginTop: 8.2,
    color: "#5C5C5C",
    fontStyle: "italic",
    textAlign: 'center'
  },
  paymentDate: {
    fontSize: 11,
    color: "#5C5C5C",
    marginTop: 1.2,
    marginBottom: 8
  },
  pendingPaymentValue: {
    fontFamily: "Montserrat",
    color: "#117AAA",
    fontSize: 15,
    fontWeight: "600"
  },
  paymentValue: {
    fontFamily: "Montserrat SemiBold",
    color: "#117AAA",
    fontSize: 15,
    fontWeight: "600"
  },
  statusContainer: {
    backgroundColor: "#14882C",
    width: 65,
    height: 15,
    borderRadius: 9,
    alignItems: "center",
    justifyContent: "center"
  },
  statusText: {
    color: "#FFFFFF",
    fontFamily: "Montserrat",
    fontSize: 11,
    fontWeight: "bold",
    paddingLeft: 6,
    paddingRight: 6,
    textTransform: "uppercase"
  },
  chevronRight: {
    marginLeft: 7.9,
    width: 10,
    height: 10,
    transform: [{
      rotate: '180deg'
    }]
  },
  recentPaymentsView: {
    marginHorizontal: 15,
    borderRadius: 10,
    shadowColor: "#000",
    paddingBottom: 4,
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    elevation: 5,
    shadowRadius: 4
  },
  rightContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: 'flex-end',
    flex: 1
  }
});
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  var Actions = require("../../../redux/actions/actions.js");
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(RecentPaymentsList);